// react
import React, { Component } from "react";

// third-party
import classNames from "classnames";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// application
import Indicator from "../header/Indicator";
import IndicatorAccount from "../header/IndicatorAccount";
import { Menu18x14Svg, // LogoSmallSvg,
  Search20Svg, Compare16Svg, Heart20Svg, Cart20Svg,} from "../../svg";
import { mobileMenuOpen } from "../../store/mobile-menu";
import Search from "../header/Search";

class MobileHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchOpen: false,
    };
    this.searchInput = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    const { searchOpen } = this.state;

    if (
      searchOpen &&
      searchOpen !== prevState.searchOpen &&
      this.searchInput.current
    ) {
      this.searchInput.current.focus();
    }
  }

  handleOpenSearch = () => {
    this.setState(() => ({ searchOpen: true }));
  };

  handleCloseSearch = () => {
    this.setState(() => ({ searchOpen: false }));
  };

  render() {
    const { openMobileMenu, wishlist, compare, cart } = this.props;
    const { searchOpen } = this.state;
    const searchClasses = classNames("mobile-header__search", {
      "mobile-header__search--open": searchOpen,
    });

    return (
      <div className="mobile-header">
        <div className="mobile-header__panel">
          <div className="container">
            <div className="mobile-header__body">
              <button
                type="button"
                className="mobile-header__menu-button"
                onClick={openMobileMenu}
                aria-label="Open navigation menu"
              >
                <Menu18x14Svg />
              </button>
              <Link to="/" className="mobile-header__logo">
                <img src="images/logos/logo-mobile.png" alt="My UAE Startup" />
              </Link>
              <Search
                context="mobile-header"
                className={searchClasses}
                inputRef={this.searchInput}
                onClose={this.handleCloseSearch}
              />
              <div className="mobile-header__indicators">
                <Indicator
                  className="indicator--mobile indicator--mobile-search d-md-none"
                  onClick={this.handleOpenSearch}
                  icon={<Search20Svg />}
                  name1="Search"
                />
                <Indicator
                  className="indicator--mobile mobile-header__indicator d-sm-flex"
                  url="/shop/compare"
                  value={compare.items.length}
                  icon={<Compare16Svg />}
                  name1="Compare"
                />
                <Indicator
                  className="indicator--mobile mobile-header__indicator d-sm-flex"
                  url="/shop/wishlist"
                  value={wishlist.length}
                  icon={<Heart20Svg />}
                  name1="Wishlist"
                />
                <Indicator
                  className="indicator--mobile mobile-header__indicator"
                  url="/shop/cart"
                  value={cart.quantity}
                  icon={<Cart20Svg />}
                  name1="Cart"
                />
                <IndicatorAccount
                  mobile
                  className="indicator--mobile mobile-header__indicator"
                  index={2}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  cart: state.cart,
  wishlist: state.wishlist,
  compare: state.compare,
});

const mapDispatchToProps = {
  openMobileMenu: mobileMenuOpen,
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileHeader);
